module.exports = __webpack_public_path__ + "static/media/services_small.92587c65.jpg";